import { LineChart, Globe, Layers, Zap, Brush, BadgeCheck } from "lucide-react";
import Reveal from "@/components/common/Reveal";

const items = [
  { Icon: LineChart, title: "Data-driven decisions", desc: "Every change is hypothesis-driven, A/B tested, and tied to revenue." },
  { Icon: BadgeCheck, title: "Conversion-focused execution", desc: "We obsess over CVR, AOV, and LTV — not vanity metrics." },
  { Icon: Globe, title: "Global client experience", desc: "120+ brands across USA, UK, EU, UAE & APAC trust Kavion." },
  { Icon: Layers, title: "Full-funnel growth", desc: "Acquisition, conversion, and retention working as one system." },
  { Icon: Zap, title: "Fast turnaround", desc: "Avg redesign launch in 21 days. Ad accounts live in 72 hours." },
  { Icon: Brush, title: "Creative + Performance", desc: "Brand-grade creative engineered to perform on cold traffic." },
];

export default function WhyChoose() {
  return (
    <section data-testid="why-choose-section" className="relative py-24 md:py-32">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid lg:grid-cols-12 gap-10">
          <div className="lg:col-span-5">
            <span className="text-xs uppercase tracking-[0.25em] text-blue-400 font-bold">Why Kavion</span>
            <h2 className="mt-4 font-display text-4xl md:text-5xl lg:text-6xl font-extrabold text-white tracking-tight leading-[1.05]">
              An unfair growth<br />advantage for<br /><span className="text-gradient">ambitious brands.</span>
            </h2>
            <p className="mt-5 text-zinc-400 leading-relaxed">
              We don't run campaigns or ship mockups. We build conversion systems that compound month over month.
            </p>
          </div>
          <div className="lg:col-span-7 grid sm:grid-cols-2 gap-4">
            {items.map((it, i) => (
              <Reveal key={it.title} delay={i * 0.05}>
                <div className="h-full rounded-2xl glass p-6 hover:bg-white/[0.05] transition">
                  <div className="h-10 w-10 grid place-items-center rounded-xl bg-blue-500/15 border border-blue-400/20">
                    <it.Icon className="h-5 w-5 text-blue-300" />
                  </div>
                  <h3 className="mt-4 font-display text-lg font-bold text-white">{it.title}</h3>
                  <p className="mt-2 text-sm text-zinc-400 leading-relaxed">{it.desc}</p>
                </div>
              </Reveal>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
